import { getEmailLoginSession } from "@/services/get-email-login-session";
import { sendEmailVerifyCode } from "@/services/send-email-verify-code";
import {
  iamEmailManager,
  iamFirstLoginManager,
  iamEmailSessionIdManager,
} from "@/manager";

export function useAPISendVerifyCode() {
  const handleSendVerifyCode = async (email: string, agentId?: string) => {
    const data = await getEmailLoginSession(email, agentId);
    iamEmailManager.update(email);
    iamEmailSessionIdManager.update(data.emailSessionId);
    iamFirstLoginManager.update(data.firstLogin);
    await sendEmailVerifyCode(data.emailSessionId);
  };

  return {
    handleSendVerifyCode,
  };
}
